import React from "react"
import PropTypes from "prop-types"

const UnMuteIcon = ({ style }) => (
  <svg style={style} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48.4 43">
    <path
      d="M9.3 10.3L21.6 0v43L9.2 32.7 0 31.3v-20l9.3-1zm1.9 4.6l-6.5.6v11.8l6.5 1 5.7 4.8v-23l-5.7 4.8zm22.4 6.9c0 5.2-1.4 10.1-3.9 14.3l-3.8-2.8c1.9-3.4 3-7.4 3-11.6 0-4.3-1.2-8.4-3.2-11.9l3.8-2.7c2.7 4.3 4.1 9.3 4.1 14.7zm8.5 0c0 7.1-2 13.6-5.4 19.3l-3.8-2.7c2.9-4.9 4.6-10.5 4.6-16.5 0-6.2-1.7-11.9-4.7-16.8l3.8-2.7c3.5 5.5 5.5 12.2 5.5 19.4z"
      fill="currentColor"
    />
  />
  </svg>
)

UnMuteIcon.propTypes = {
  style: PropTypes.object
}

export default UnMuteIcon



// WEBPACK FOOTER //
// ./src/components/icons/unmute-icon.jsx